import Estimations, { isSameMonth, MonthEstimation } from '../../../domain/estimations/Estimations';

export const parseEstimations = (existingEstimations: Estimations, importedEstimations: Estimations): Estimations => {
    if (existingEstimations.length === 0) {
        return importedEstimations;
    } else {
        return [
            ...existingEstimations
                .filter(
                    (estimation: MonthEstimation) =>
                        importedEstimations.find((eventEstimation: MonthEstimation) =>
                            isSameMonth(eventEstimation.month, estimation.month)
                        ) === undefined
                )
                .map((estimation: MonthEstimation) => {
                    return {
                        ...estimation,
                        articlesEstimations: []
                    };
                }),
            ...importedEstimations
        ];
    }
};



// WEBPACK FOOTER //
// ./src/application/estimations/reducer/importFromExcel.ts